jQuery_T4NT(document).ready(function($) {
  function parcelamento() {
  var preco = $('#shopify-section-pr_summary .price_varies.current_price, #shopify-section-pr_summary .price_range ins').text().split('                  ')[0].replace('R$ ','').replace(',', '.').split(' ')[0].split('-')[0].split('C')[0].trim()
  var compare = $('#shopify-section-pr_summary .precode').text().replace('R$ ', '').replace(',','.')
  var compare = parseFloat(compare)
  var precompare = (compare - preco).toFixed(2).replace('.', ',')
  $('#shopify-section-pr_summary .product-label.product-label--on-sale span').text('R$ '+ precompare)
  var porcent = ((compare - preco) * 100 / compare).toFixed(2).split('.')[0]
  $('#shopify-section-pr_summary .precocheio .product-label.product-label--on-sale').empty()
  $('#shopify-section-pr_summary .price--highlight .product-label.product-label--on-sale').append( porcent + '% OFF')    
  var preco = parseFloat(preco);
  var calculo = ((preco + 0) * 1.0) / 3;
  var calculo = calculo.toFixed(2).replace('.', ',');
  var calculo = ('R$ ' + calculo);
  $('#shopify-section-pr_summary .parcelamento').html('<span><h>em até</h> 3x de <b>' + calculo + '</b></span>');
  }


  $(".nt-swatch").click(function () {
      setTimeout(function () { parcelamento(); }, 150);
  });
  
})